module.exports = __webpack_public_path__ + "assets/img/17_1094_big.75593fb9.jpg";